import { getPivotBlueshiftParams } from 'core/services/email/blueshift/implementations/generic'
import store from 'utils/store/withMiddleware'
import { ISC } from 'core/constants/channels'
import { sendBlueshiftEvent, BlueshiftEvent } from 'core/services/email/blueshift'

export function sendEmailQuoteEvent(quote: string): Promise<void> {
  const state = <Pivot.GenericKeyPair<any>>store.getState()
  const { hcStorage } = state

  const dataPayload = {
    ...getPivotBlueshiftParams(),
    quote_link: quote
  }

  return sendBlueshiftEvent({
    dataPayload,
    eventName:
      dataPayload.sales_channel === ISC
        ? BlueshiftEvent.ISC_EMAIL_QUOTE
        : BlueshiftEvent.EMAIL_QUOTE,
    sanitize: true
  })
}
